import Head from 'next/head';
import React, { FunctionComponent } from 'react';

import { LOCALES, PRODUCTION_DOMAIN } from '../../../constants';
import { PageSeo } from '../../../types';
import { BasicSeoElements } from '../BasicSEO';
import { useBabelSeo } from '../useBabelSeo';

type SearchResultsPageSEOProps = {
  pageSeo: PageSeo;
  term?: string;
};

export const SearchResultsPageSEO: FunctionComponent<
  SearchResultsPageSEOProps
> = ({ pageSeo, term = '' }: SearchResultsPageSEOProps) => {
  const resolveBabelSeo = useBabelSeo();
  const title = resolveBabelSeo(
    'seo.search_results_page.title',
    pageSeo?.title,
  );

  return (
    <>
      <BasicSeoElements
        title={title}
        description={pageSeo?.description}
        imageUrl={pageSeo?.imageUrl}
        robots={pageSeo?.robots}
      />
      <Head>
        {Object.values(LOCALES).map((targetLocale) => (
          <link
            rel="alternate"
            hrefLang={targetLocale}
            href={`https://${PRODUCTION_DOMAIN}/${targetLocale}/search?term=${term}`}
            key={`/${targetLocale}/search?term=${term}`}
          />
        ))}
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`https://${PRODUCTION_DOMAIN}/${LOCALES.EN}/search?term=${term}`}
        />
      </Head>
    </>
  );
};
